import { createReducer } from '@ngrx/store';

import { AppState } from '../shared/models';

export const appReducer = createReducer<AppState>({});
